import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

interface IProps {
  src: string;
}

export const Container = styled.div`
  min-width: calc(100% - 88px);

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  h3 {
    font-family: 'Roboto';
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  .unread-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #e53935;
    margin-left: 10px;
    animation: pulse-unread 1.4s infinite;
  }

  .unread-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 9px;
    background: #e53935;
    color: #fff;
    font-size: 10px;
    line-height: 18px;
    text-align: center;
  }

  .unread-row {
    background: #fff1f0;
    border-left: 4px solid #e53935;
  }

  @keyframes pulse-unread {
    0% {
      box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.6);
    }
    70% {
      box-shadow: 0 0 0 8px rgba(229, 57, 53, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(229, 57, 53, 0);
    }
  }

  a {
    :hover {
      color: unset;
    }
  }

  p {
    color: #878787;
    font-size: 14px;
    font-weight: 400;
  }

  .infinite-scroll {
    height: calc(100vh - 36px);
    overflow: auto;

    ::-webkit-scrollbar {
      width: 0;
    }

    ::-webkit-scrollbar-thumb {
      background-color: transparent !important;
    }
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pending {
    color: #ff003d;
  }

  .visualized {
    color: #ffa800;
  }

  .solved {
    color: #00b15c;
  }

  .date {
    color: #8c8c8c;
  }

  .status {
    font-family: 'Roboto';
  }

  .bg-orange {
    background-color: #ff842f;
    padding: 4px 8px;
  }

  .bg-contact {
    border-radius: 4px;
    border: 1px solid rgba(221, 221, 221, 0.87);
    padding: 5px 8px;
    color: #5e5e5e;
    font-weight: 400;
  }

  .container-fluid {
    max-width: 1460px;
  }

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
  }

  .bg-white {
    border-radius: 8px;
  }
`;

export const Avatar = styled.div<IProps>`
  background-image: url(${(props) => props.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 37px;
  min-height: 37px;
  border-radius: 64px;
  border: 1px solid #8c8c8c;
`;

export const Filter = styled.div`
  h2 {
    color: #000;
    font-family: 'Roboto';
  }
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .name {
    color: #a3a3a3;
    font-size: 14px;
  }

  .height-chat {
    border-radius: 8px;
    padding: 8px;
    height: 300px;
    overflow: auto;
    display: flex;
    flex-direction: column-reverse;
    background: #f6f6f6;

    ::-webkit-scrollbar-thumb {
      background-color: #909090;
      border-radius: 4px;
    }
  }

  .answer {
    border: 1px solid #ddd;
    border-radius: 8px;
  }

  .details-box {
    border-radius: 8px;
    background: #f6f6f6;
    padding: 12px 16px;
    max-height: 220px;
    overflow: auto;
  }

  .details-group + .details-group {
    margin-top: 12px;
  }

  .details-title {
    color: #333;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .details-item {
    color: #5a5a5a;
    margin-bottom: 2px;
    white-space: pre-line;
    word-break: break-word;
  }

  .chat-ballon {
    max-width: 90%;
    width: max-content;
  }

  .bg-me {
    border-radius: 16px;
    border-bottom-right-radius: 0px;
    background: #ffeee3;
    color: #5a5a5a;
    font-family: 'Poppins';
    font-size: 14px;
    font-weight: 400;
  }

  .bg {
    border-radius: 16px;
    border-bottom-left-radius: 0px;

    color: #5a5a5a;
    font-family: 'Poppins';
    font-size: 14px;
    font-weight: 400;
  }

  .send {
    background: #ff6900;
    border-radius: 25px;
    color: #fff;
    font-weight: 500;
    border: none;
    padding: 8px 11px;
    font-size: 16px;
    border: 1px solid #ff6900;
    transition: all ease 0.2s;
    svg path {
      color: #fff;
    }
    :active {
      color: #ff6900;
      background: #fff;
      border: 1px solid #ff6900;
      svg path {
        color: #ff6900;
      }
    }
  }
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .new {
    color: #f22525;
    border-radius: 25px;
    background: #ffe1e1;
  }

  .visualized {
    color: #ffa800;
    border-radius: 25px;
    background: #fff1d6;
  }

  .solved {
    color: #00b15c;
    border-radius: 25px;
    background: #dffff0;
  }

  .btn-filter {
    border-radius: 8px;
    background-color: transparent;
    color: #ff6900;
    font-size: 14px;
    border: 1px solid #ff6900;

    :active {
      color: #fff;
      background: #ff6900;
      border: 1px solid #ff6900;
    }
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }

  @media screen and (min-width: 992px) {
    .chat-ballon {
      max-width: 75%;
    }
    .name {
      font-size: 16px;
    }

    .btn-filter {
      font-size: 16px;
    }
  }
`;
